import type { IPlatformUtils } from '@wix/thunderbolt-symbols'

export interface WixEcomFrontendWixCodeSdkWixCodeApi {
	refreshCart(): Promise<void>
	onCartChange(handler: () => void): void
	openSideCart(): void
	navigateToCartPage(): Promise<any>
	getCustomerSelectedCurrency(): Promise<string>
	navigateToCheckoutPage(
		checkoutId: string,
		options?: {
			skipDeliveryStep?: boolean
			hideContinueShoppingButton?: boolean
			overrideContinueShoppingUrl?: string
			overrideThankYouPageUrl?: string
		}
	): Promise<any>
}

export interface WixEcomFrontendWixCodeSdkHandlers extends Record<string, Function> {}

/**
 * Site feature config is calculated in SSR when creating the `viewerModel`
 * The config is available to your feature by injecting `named(PageFeatureConfigSymbol, name)`
 */
export type WixEcomFrontendWixCodeSdkSiteConfig = {}

export interface CreateBiLoggerParams {
	biUtils: IPlatformUtils['biUtils']
	msid: string
}

export enum MethodNames {
	refreshCart = 'refreshCart',
	onCartChange = 'onCartChange',
	openSideCart = 'openSideCart',
	navigateToCartPage = 'navigateToCartPage',
	navigateToCheckoutPage = 'navigateToCheckoutPage',
	getCustomerSelectedCurrency = 'getCustomerSelectedCurrency',
}
